import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

function Privacy() {
  return (
    <Container className="py-5 text-light">
      <Row className="justify-content-center">
        <Col lg={8}>
          <h1 className="h3 fw-bold">Privacy</h1>
          <p className="text-white-50">This is a placeholder. Arkodomo does not collect personal data on this demo site. Contact us for details.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default Privacy;
